import HttpClient from "../../utils/HttpClient";

export class BoardService {
    static BASE_PATH = '/tm/boards';

    // Board operations
    static async getBoards() {
        const response = await HttpClient.get(`${this.BASE_PATH}`);
        return response.data.data;
    }

    static async createBoard(data) {
        const response = await HttpClient.post(`${this.BASE_PATH}`, data);
        return response.data.data;
    }

    static async getBoard(boardId) {
        const response = await HttpClient.get(`${this.BASE_PATH}/${boardId}`);
        return response.data.data;
    }

    static async getDetail(boardId) {
        const response = await HttpClient.get(`${this.BASE_PATH}/${boardId}/detail`);
        return response.data.data;
    }

    static async update(boardId, data) {
        const response = await HttpClient.put(`${this.BASE_PATH}/${boardId}`, data);
        return response.data.data;
    }

    static async delete(boardId) {
        await HttpClient.delete(`${this.BASE_PATH}/${boardId}`);
    }

    // Get properties
    static async getProperties() {
        const response = await HttpClient.get('/ui/ga-properties');
        return response.data;
    }

    // Get manual clients
    static async getManualClients() {
        const response = await HttpClient.get('/ui/manual-client-website');
        return response.data;
    }

    // Get groups
    static async getGroups() {
        const response = await HttpClient.get('/ui/group-properties-or-clients');
        return response.data;
    }

    // Update board assignments
    static async updateAssignments(boardId, assignments) {
        const response = await HttpClient.put(`${this.BASE_PATH}/${boardId}/assignments`, assignments);
        return response.data.data;
    }

    // Get properties
    static async getProperties() {
        const response = await HttpClient.get('/ui/ga-properties');
        return response.data;
    }

    // Get manual clients
    static async getManualClients() {
        const response = await HttpClient.get('/ui/manual-client-website');
        return response.data;
    }

    // Get groups
    static async getGroups() {
        const response = await HttpClient.get('/ui/group-properties-or-clients');
        return response.data;
    }

    // Update board assignments
    static async updateAssignments(boardId, assignments) {
        const response = await HttpClient.put(`${this.BASE_PATH}/${boardId}/assignments`, assignments);
        return response.data.data;
    }

    // List operations
    static async getLists(boardId) {
        const response = await HttpClient.get(`${this.BASE_PATH}/${boardId}/lists`);
        return response.data.data;
    }

    static async getList(boardId, listId) {
        const response = await HttpClient.get(`${this.BASE_PATH}/${boardId}/lists/${listId}`);
        return response.data.data;
    }

    static async createList(boardId, data) {
        const response = await HttpClient.post(`${this.BASE_PATH}/${boardId}/lists`, data);
        return response.data.data;
    }

    static async updateList(boardId, listId, data) {
        const response = await HttpClient.put(`${this.BASE_PATH}/${boardId}/lists/${listId}`, data);
        return response.data.data;
    }

    static async deleteList(boardId, listId) {
        await HttpClient.delete(`${this.BASE_PATH}/${boardId}/lists/${listId}`);
    }

    static async reorderLists(boardId, listIds) {
        await HttpClient.post(`${this.BASE_PATH}/${boardId}/lists/reorder`, {
            lists: listIds
        });
    }

    // Task operations
    static async getTasks(boardId, filters = {}) {
        const response = await HttpClient.get(`${this.BASE_PATH}/${boardId}/tasks`, { params: filters });
        return response.data.data;
    }

    static async getTask(boardId, taskId) {
        const response = await HttpClient.get(`${this.BASE_PATH}/${boardId}/tasks/${taskId}`);
        return response.data.data;
    }

    static async createTask(boardId, data) {
        const response = await HttpClient.post(`${this.BASE_PATH}/${boardId}/tasks`, data);
        return response.data.data;
    }

    static async updateTask(boardId, taskId, data) {
        const response = await HttpClient.post(`${this.BASE_PATH}/${boardId}/tasks/${taskId}`, data);
        return response.data.data;
    }

    static async deleteTask(boardId, taskId) {
        await HttpClient.delete(`${this.BASE_PATH}/${boardId}/tasks/${taskId}`);
    }

    static async moveTask(boardId, taskId, data) {
        await HttpClient.post(`${this.BASE_PATH}/${boardId}/tasks/${taskId}/move`, data);
    }

    // Status operations
    static async getStatuses(boardId) {
        const response = await HttpClient.get(`${this.BASE_PATH}/${boardId}/statuses`);
        return response.data.data;
    }

    static async createStatus(boardId, data) {
        const response = await HttpClient.post(`${this.BASE_PATH}/${boardId}/statuses`, data);
        return response.data.data;
    }

    static async updateStatus(boardId, statusId, data) {
        const response = await HttpClient.put(`${this.BASE_PATH}/${boardId}/statuses/${statusId}`, data);
        return response.data.data;
    }

    static async deleteStatus(boardId, statusId) {
        await HttpClient.delete(`${this.BASE_PATH}/${boardId}/statuses/${statusId}`);
    }

    static async reorderStatuses(boardId, statusIds) {
        await HttpClient.post(`${this.BASE_PATH}/${boardId}/statuses/reorder`, {
            statuses: statusIds
        });
    }

    // Label operations
    static async getLabels(boardId) {
        const response = await HttpClient.get(`${this.BASE_PATH}/${boardId}/labels`);
        return response.data.data;
    }

    static async createLabel(boardId, data) {
        const response = await HttpClient.post(`${this.BASE_PATH}/${boardId}/labels`, data);
        return response.data.data;
    }

    static async updateLabel(boardId, labelId, data) {
        const response = await HttpClient.put(`${this.BASE_PATH}/${boardId}/labels/${labelId}`, data);
        return response.data.data;
    }

    static async deleteLabel(boardId, labelId) {
        await HttpClient.delete(`${this.BASE_PATH}/${boardId}/labels/${labelId}`);
    }

    static async assignLabelToTask(boardId, labelId, taskId) {
        await HttpClient.post(`${this.BASE_PATH}/${boardId}/labels/${labelId}/tasks/${taskId}`);
    }

    static async removeLabelFromTask(boardId, labelId, taskId) {
        await HttpClient.delete(`${this.BASE_PATH}/${boardId}/labels/${labelId}/tasks/${taskId}`);
    }

    // Comment operations
    static async getComments(boardId, taskId) {
        const response = await HttpClient.get(`${this.BASE_PATH}/${boardId}/tasks/${taskId}/comments`);
        return response.data.data;
    }

    static async createComment(boardId, taskId, data) {
        const response = await HttpClient.post(`${this.BASE_PATH}/${boardId}/tasks/${taskId}/comments`, data);
        return response.data.data;
    }

    static async updateComment(boardId, taskId, commentId, data) {
        const response = await HttpClient.put(`${this.BASE_PATH}/${boardId}/tasks/${taskId}/comments/${commentId}`, data);
        return response.data.data;
    }

    static async deleteComment(boardId, taskId, commentId) {
        await HttpClient.delete(`${this.BASE_PATH}/${boardId}/tasks/${taskId}/comments/${commentId}`);
    }
}
